import { createSelector } from 'reselect';

import { RootState } from 'redux/schemas';
import {
  MentorshipProgramConnection,
  MentorshipProgramRequest,
} from 'redux/schemas/models/mentorship-program-connections';
import { SingleMentorRequestStatus } from 'redux/schemas/models/mentor-request';

export const getCreateConnectionModalSettings = (
  state: RootState,
) => state.app.connections.createConnectionModal;

export const getMentoringProgramConnectionsList = createSelector(
  (state: RootState) => state.models.mentorshipProgramConnections,
  (state, ids: number[]) => ids,
  (mentorshipProgramConnections: Record<number, MentorshipProgramConnection>, ids: number[]) => ids.map((id) => mentorshipProgramConnections[id]),
);

export const getMentoringRequestList = createSelector(
  (state: RootState) => state.models.mentoringProgramRequests,
  (_state, ids: number[]) => ids,
  (mentoringProgramRequests: Record<number, MentorshipProgramRequest>, ids: number[]) => (
    ids.map((id) => mentoringProgramRequests[id])
  ),
);

export const getMentoringProgramRequest = (requestId: number): (state: RootState) => MentorshipProgramRequest | undefined => (state: RootState) => (
  state.models.mentoringProgramRequests?.[requestId]
);

export const getMentoringProgramRequests = (state: RootState) => (
  Object.values(state.models.mentoringProgramRequests)
);

export const getMentoringProgramRequestsByStatus = (
  status: SingleMentorRequestStatus,
  enrollmentId: number,
) => (state: RootState) => (
  Object.values(state.models.mentoringProgramRequests).filter((request) => (
    request.state === status && (
      request.menteeEnrollmentId === enrollmentId
      || request.mentorEnrollmentId === enrollmentId
    )
  ))
);

export const getMentorRequestCarouselIndex = (state: RootState) => (
  state.app.mentorRequestCarouselIndex
);

export const getMentoringRequestsByParticipantId = (
  participantId: number,
  enrollmentId: number,
  isMentee: boolean,
) => (state: RootState) => (
  Object.values(state.models.mentoringProgramRequests).filter((request) => (
    isMentee
      ? request.mentorEnrollmentId === participantId && request.menteeEnrollmentId === enrollmentId
      : request.menteeEnrollmentId === participantId && request.mentorEnrollmentId === enrollmentId
  ))
);

export const getRedirectToNewConnectionOnApproval = (state: RootState) => (
  state.app.mentoringProgram.participantDriven.redirectToNewConnectionOnApproval
);
